"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ɵngcc0 = require('@angular/core');
var BaseComponentFactory = (function () {
    function BaseComponentFactory() {
    }
    BaseComponentFactory.prototype.createFilterFromComponent = function (componentType, viewContainerRef) {
        console.log("Use AgGridModule.withComponents() if you wish to use dynamic components");
        throw Error("Method not implemented");
    };
BaseComponentFactory.ɵfac = function BaseComponentFactory_Factory(t) { return new (t || BaseComponentFactory)(); };
BaseComponentFactory.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BaseComponentFactory, factory: function (t) { return BaseComponentFactory.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BaseComponentFactory, [{
        type: core_1.Injectable
    }], function () { return []; }, null); })();
    return BaseComponentFactory;
}());
/** @nocollapse */
BaseComponentFactory.ctorParameters = function () { return []; };
exports.BaseComponentFactory = BaseComponentFactory;

